<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="level jc-sb ai-c">
                    <span>
                        Import Log
                    </span>
                </div>
            </div>

            <div class="panel-body">
                <table class="table log has-mobile-cards">
                    <thead>
                        <tr>
                            <th>Vendor</th>
                            <th>Type</th>
                            <th>Account</th>
                            <th class="status">Status</th>
                            <th class="reason"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td data-label="Vendor">
                                {{ item.vendor }}
                            </td>
                            <td data-label="Type">
                                {{ item.type }}
                            </td>
                            <td data-label="Account">
                                {{ item.account }}
                            </td>
                            <td data-label="Status" class="status">
                                <span :class="'fa ' +  statusClasses(item.status)"></span>
                            </td>
                            <td data-label="Info" class="reason">
                                <button class="btn btn-default" @click="showItemInfo(item)" v-if="item.reason">
                                    <span class="fa fa-info"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="level jc-sb ai-c paginator">
                    <button class="btn btn-default" v-if="page.current > 1" @click="previousPage">Prev</button>
                    <span v-else></span>
                    <button class="btn btn-default" v-show="page.current !== page.last" @click="nextPage">Next</button>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modal-item-info" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button " class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

                        <h4 class="modal-title">
                            Details
                        </h4>
                    </div>
                    <div class="modal-body">
                        <h4>{{ activeItem.vendor }}: {{ activeItem.type }}</h4>
                        <pre><code>{{ activeItem.reason }}</code></pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user'],

        data() {
            return {
                items: [],
                page: {
                    current: 1,
                    last: 1,
                    from: 0,
                    to: 0
                },
                activeItem: {}
            };
        },

        mounted() {
            this.getImportLog();
        },

        methods: {
            getImportLog() {
                axios.get(`/api/imports/log?page=${this.page.current}`)
                    .then(({data}) => {
                        this.items = data.data;
                        this.page.last = data.last_page;
                        this.page.from = data.from;
                        this.page.to = data.to;
                    });
            },

            nextPage() {
                this.page.current++;
                this.getImportLog();
            },
            
            previousPage() {
                this.page.current--;
                this.getImportLog();
            },

            statusClasses(status) {
                switch (status) {
                    case 'completed':
                        return 'fa-check-circle success';
                    case 'failed':
                        return 'fa-times-circle error';
                    case 'queued':
                        return 'fa-clock pending';
                    default:
                        return 'fa-question-circle pending';
                }
            },

            showItemInfo(item) {
                this.activeItem = item;
                $('#modal-item-info').modal('show');
            }
        }
    }
</script>
<style>
@media screen and (min-width: 768px) {
    
table.table.log th:not(.status):not(.reason),
table.table.log td:not(.status):not(.reason) {
    width: 26%;
    height: 54px;
}

table.table.log th.status,
table.table.log th.reason,
table.table.log td.status,
table.table.log td.reason {
    width: 11%;
    height: 54px;
}

}

div.paginator button,
div.paginator span {
    width: 80px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/imports/ImportLog.vue